import React, { memo } from 'react';
import ShowHide from './_ShowHide';

const ExamModeShow = ({ children, ...rest }) => {
  return <ShowHide {...rest} requiredExamMode={true}>{children}</ShowHide>
}

export default memo(ExamModeShow);
